import { useRef, useState } from 'react';
import L from 'leaflet';

const useGeoJsonLayers = ({
  zoomLevel,
  primaryColor,
  secondaryColor,
  tertiaryColor,
  setSelectedFeature,
  setSelectedLocId
}) => {
  const selectedLayerRef = useRef(null);
  const radius = Math.min(Math.pow(2, zoomLevel - 7), Math.pow(2, 4));

  const handleGeoJsonPointClick = (locId) => {
    setSelectedLocId(locId);
  };

  const onEachFeature = (feature, layer) => {
    layer.originalColor = layer.options.color;

    layer.on('mouseover', () => {
      if (layer !== selectedLayerRef.current) {
        layer.setStyle({
          color: 'red',
          weight: 15
        });
      }
    });

    layer.on('mouseout', () => {
      if (layer !== selectedLayerRef.current) {
        layer.setStyle({
          color: layer.originalColor,
          weight: 3
        });
      }
    });

    layer.on('click', () => {
      if (selectedLayerRef.current && selectedLayerRef.current !== layer) {
        selectedLayerRef.current.setStyle({
          color: selectedLayerRef.current.originalColor,
          weight: 3
        });
      }

      // set ref و state
      selectedLayerRef.current = layer;
      // فقط این کافیه:
      // استایل marker فعلی
      layer.setStyle({
        color: 'red',
        weight: 8
      });

      setSelectedFeature(feature.properties);
      const locId = feature.properties.loc_id || feature.properties.stationpkid;
      handleGeoJsonPointClick(locId);
    });
  };

  const pointToLayer = (feature, latlng) =>
    L.circleMarker(latlng, {
      radius,
      color: primaryColor,
      fillOpacity: 1,
      weight: 3
    });

  const pointToLayer2 = (feature, latlng) =>
    L.circleMarker(latlng, {
      radius,
      color: secondaryColor,
      fillOpacity: 1,
      weight: 3
    });

  const pointToLayer3 = (feature, latlng) =>
    L.circleMarker(latlng, {
      radius,
      color: tertiaryColor,
      fillOpacity: 1,
      weight: 3
    });

  return {
    onEachFeature,
    pointToLayer,
    pointToLayer2,
    pointToLayer3
  };
};

export default useGeoJsonLayers;
